export function getSubdomainPart(): string {
  const subdomainPart: string = window.location.hostname.split('.')[0];
  if (subdomainPart.startsWith('demo-')) return subdomainPart.slice(5);
  return subdomainPart;
}
